import services from 'api/services';
import { logError } from 'util/errors';

import {
  LOAD_CMS_CANDIDATE_INFO_REQUEST,
  LOAD_CMS_CANDIDATE_INFO_SUCCESS,
  LOAD_CMS_CANDIDATE_INFO_FAILURE,
  ARCHIVE_SUBMISSION_REQUEST,
  ARCHIVE_SUBMISSION_SUCCESS,
  ARCHIVE_SUBMISSION_FAILURE,
  RESET_UPDATED_IDS,
} from './constants';

const { AccountService, ChallengeSubmissionService, TournamentSubmissionService } = services;

export const getParticipantProfileForCMS = (accountId, contestId) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_CMS_CANDIDATE_INFO_REQUEST });
    const response = await AccountService.getParticipantProfileForCMS(accountId, contestId);
    dispatch({ type: LOAD_CMS_CANDIDATE_INFO_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_CMS_CANDIDATE_INFO_FAILURE, error: ex.message });
  }
};

export const archiveSubmission = (accountId, contestId, isTournament) => async (dispatch) => {
  try {
    dispatch({ type: ARCHIVE_SUBMISSION_REQUEST });
    const response = isTournament
      ? await TournamentSubmissionService.archiveSubmission(accountId, contestId)
      : await ChallengeSubmissionService.archiveSubmission(accountId, contestId);
    dispatch({ type: ARCHIVE_SUBMISSION_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: ARCHIVE_SUBMISSION_FAILURE, error: ex.message });
  }
};

export const resetUpdatedIds = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATED_IDS });
};
